export default "__VITE_ASSET__kjKHnb7d__ 400w, __VITE_ASSET__Cijin7F0__ 800w, __VITE_ASSET__D4zTlqka__ 1024w";